const headers = [
    {
        text: 'Todos',
        align: 'left',
        value: 'all',
        sortable: false,
        class: 'table-b-border  black--text'
    },
    {
        text: 'Crear',
        align: 'left',
        value: 'store',
        sortable: false,
        class: 'table-b-border  black--text'
    },
    {
        text: 'Ver',
        align: 'left',
        value: 'show',
        sortable: false,
        class: 'table-b-border  black--text'
    },
    {
        text: 'Editar',
        align: 'left',
        value: 'edit',
        sortable: false,
        class: 'table-b-border  black--text'
    },
    {
        text: 'Borrar',
        align: 'left',
        value: 'delete',
        sortable: false,
        class: 'table-b-border  black--text'
    },
   
]

const modules = [
  // {label:"Root", submodules:[ {key:"root", label: "Administrador"} ]},
    {
        props: {
            headers: [
                {
                    text: 'Dashboard',
                    align: 'left',
                    value: 'label',
                    sortable: false,
                    width:'40%',
                    class: 'table-b-border  black--text'
                },
                ...headers
            ],
            
        },
        label: "Dashboard",
        submodules: [
            
            { key: "dashboards", label: "Dashboard", notIn:['reactive', 'store', 'edit', 'delete', 'index', 'update_amount', 'request']  },
        ],
    },
    {
        props: {
            headers: [
                {
                    text: 'Supervisión',
                    align: 'left',
                    value: 'label',
                    sortable: false,
                    width:'40%',
                    class: 'table-b-border  black--text'
                },
                ...headers
            ],
            
        },
        label: "Supervisión",
        submodules: [
            
            { key: "supervisions", label: "Supervisión", notIn:['reactive', 'store', 'edit', 'delete', 'update_amount', 'request']  },
        ],
    },
    {
        props: {
            headers: [
                {
                    text: 'Inventario',
                    align: 'left',
                    value: 'label',
                    sortable: false,
                    width:'40%',
                    class: 'table-b-border  black--text'
                },
                ...headers
            ],
            
        },
        label: "Inventario",
        submodules: [
            
            // { key: "consumables", label: "Consumible", notIn:['reactive', 'update_amount', 'request']  },
            { key: "equipments", label: "Equipos", notIn:['reactive', 'update_amount', 'request'] },
            
            { key: "supplies", label: "Insumos", notIn:['reactive', 'update_amount', 'request']  },
        ],
    },
    {
        props: {
            headers: [
                {
                    text: 'Compras',
                    align: 'left',
                    value: 'label',
                    sortable: false,
                    width:'40%',
                    class: 'table-b-border  black--text'
                },
                ...headers,
                {
                    text: 'Revisar',
                    align: 'left',
                    value: 'request',
                    sortable: false,
                    class: 'table-b-border  black--text'
                },
                {
                    text: 'Reactivar',
                    align: 'left',
                    value: 'reactive',
                    sortable: false,
                    class: 'table-b-border  black--text'
                },
            ],
           
        },
        label: "Compras",
        submodules: [
           
            { key: "suppliers", label: "Proveedores", notIn:['reactive', 'update_amount', 'request']  },
            { key: "purchaseOrders", label: "Órdenes de compra", notIn:['reactive', 'update_amount', 'request']  },
            { key: "requisitions", label: "Requisiciones", notIn:[ 'update_amount']  },
            { key: "entryOrders", label: "Órdenes de entrada", notIn:['reactive', 'update_amount', 'request'] },
           
            
        ],
    },
    {
        props: {
            headers: [
                {
                    text: 'Ventas',
                    align: 'left',
                    value: 'label',
                    sortable: false,
                    width:'40%',
                    class: 'table-b-border  black--text'
                },
                ...headers
            ],
           
        },
        label: "Ventas",
        submodules: [
           
            { key: "prospects", label: "Prospectos", notIn:['reactive', 'update_amount', 'request']  },
            { key: "fee", label: "Cotizaciones", notIn:['reactive', 'update_amount', 'request']  },
            { key: "clients", label: "Clientes", notIn:['reactive', 'update_amount', 'request']  },
            { key: "quotations", label: "Tarifas", notIn:['reactive', 'update_amount', 'request']  },
            { key: "clientContacts", label: "Contactos", notIn:['reactive', 'update_amount', 'request']  },
           
            { key: "services", label: "Servicios", notIn:['reactive', 'update_amount', 'request']  },
           
            
        ],
    },
    {
        props: {
            headers: [
                {
                    text: 'Operaciones',
                    align: 'left',
                    value: 'label',
                    sortable: false,
                    width:'40%',
                    class: 'table-b-border  black--text'
                },
                ...headers,
                {
                    text: 'Precios',
                    align: 'left',
                    value: 'update_amount',
                    sortable: false,
                    class: 'table-b-border  black--text'
                },
            ],
           
        },
        label: "Operaciones",
        submodules: [
            { key: "saleOrders", label: "Remisiones", notIn: ['request', 'reactive'] },
            { key: "billings", label: "Facturaciones", notIn:['reactive', 'edit', 'update_amount', 'request'] },
            
        ],
    },
    {
        props: {
            headers: [
                {
                    text: 'Catálogos',
                    align: 'left',
                    value: 'label',
                    sortable: false,
                    width:'40%',
                    class: 'table-b-border  black--text'
                },
                ...headers
            ],
           
        },
        label: "Catálogos",
        submodules: [
            { key: "warehouses", label: "Almacenes", notIn:['reactive', 'update_amount', 'request']  },
            { key: "banks", label: "Bancos", notIn:['reactive', 'update_amount', 'request']  },
            { key: "departments", label: "Departamentos", notIn:['reactive', 'update_amount', 'request']  },
            { key: "packagings", label: "Embalajes", notIn:['reactive', 'update_amount', 'request']  },
            { key: "types", label: "Tipos", notIn:['reactive', 'update_amount', 'request']  },
            { key: "units", label: "Unidades", notIn:['reactive', 'update_amount', 'request']  },
            
        ],
    },
    {
        props: {
            headers: [
                {
                    text: 'Accesos',
                    align: 'left',
                    value: 'label',
                    sortable: false,
                    width:'40%',
                    class: 'table-b-border  black--text'
                },
                ...headers
            ],
           
        },
        label: "Accesos",
        submodules: [
            { key: "roles", label: "Roles", notIn:['reactive', 'update_amount', 'request']  },
            { key: "users", label: "Usuarios", notIn:['reactive', 'update_amount', 'request']  },
        ],
    },
    {
        props: {
            headers: [
                {
                    text: 'Reportes',
                    align: 'left',
                    value: 'label',
                    sortable: false,
                    width:'40%',
                    class: 'table-b-border  black--text'
                },
                ...headers
            ],
           
        },
        label: "Reportes",
        submodules: [
            { key: "reports_requisitions", label: "Requisiciones", notIn:['reactive', 'store', 'edit', 'delete',  'update_amount', 'request']  },
            // { key: "reports_entryOrders", label: "Órdenes de entrada", notIn:['reactive', 'store', 'edit', 'delete',  'update_amount', 'request']  },
            { key: "reports_purchaseOrders", label: "Órdenes de compra", notIn:['reactive', 'store', 'edit', 'delete',  'update_amount', 'request']  },
        ],
    },
    {
        props: {
            headers: [
                {
                    text: 'Permisos especiales',
                    align: 'left',
                    value: 'label',
                    sortable: false,
                    width:'40%',
                    class: 'table-b-border  black--text'
                },
                ...headers
            ],
           
        },
        label: "Permisos especiales",
        submodules: [
            { key: "confirm_entry_order", label: "Confirmar orden de entrada", notIn:['reactive', 'edit', 'show', 'delete',  'update_amount', 'request', 'all']  },
        ],
    },
];

export default modules;
